import stores from '@/storage/stores'
import { computed, ref, watch } from 'vue'

export const theme = ref(localStorage.getItem('theme') || 'default')

const VALID_THEMES = [
  'default',
  'smoke',
  'smoke-white',
  'happy-light',
  'happy-dark'
]


export const applyTheme = (newTheme: string) => {
  if (!VALID_THEMES.includes(newTheme)) {
    newTheme = 'default'
  }

  document.documentElement.classList.remove(...VALID_THEMES)
  document.documentElement.classList.add(newTheme)
  theme.value = newTheme
  localStorage.setItem('theme', newTheme)
}

export const isThemeHappy = computed(() => {
  const isHappy = theme.value === 'happy-dark' || theme.value === 'happy-light' ? true : false
  return isHappy
})

export const isThemeDefault = computed(() => theme.value === 'default')